import { useEffect, useState } from "react";
import { Table } from "antd";

const FreshCallTable = ({ data, columns, tableDataRef, indexRef }: {
    data: any[];
    columns: any[];
    tableDataRef: React.MutableRefObject<any[]>;
    indexRef: React.MutableRefObject<number>;
}) => {
    const [freshSearchText, setFreshSearchText] = useState("");
    const [freshFiltered, setFreshFiltered] = useState(data);
    const [freshPagination, setFreshPagination] = useState({ current: 1, pageSize: 10 });

    useEffect(() => {
        setFreshFiltered(data);
        tableDataRef.current = data;
        indexRef.current = 0;
        setFreshSearchText("");
    }, [data]);

    const handleFreshSearch = (value: string) => {
        setFreshSearchText(value);
        const result = data.filter((record: any) =>
            Object.values(record).some((field) =>
                String(field).toLowerCase().includes(value.toLowerCase())
            )
        );
        setFreshFiltered(result);
        tableDataRef.current = result;
        indexRef.current = 0;
    };

    const enhancedColumns = [
        {
            title: "Sr.No",
            render: (_: any, __: any, index: number) =>
                (freshPagination.current - 1) * freshPagination.pageSize + (index + 1),
        },
        ...columns,
    ];

    return (
        <>
            <div className="table-top-data position-relative">
                <div className="row p-3">
                    <div className="col-sm-12 col-md-6">
                        <div className="dataTables_length" id="DataTables_Table_0_length" />
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div
                            title="Search Records"
                            id="DataTables_Table_0_filter"
                            className="dataTables_filter text-end mb-0"
                        >
                            <label>
                                <input
                                    type="search"
                                    className="form-control form-control-sm"
                                    placeholder="Search"
                                    aria-controls="DataTables_Table_0"
                                    value={freshSearchText}
                                    onChange={(e) => handleFreshSearch(e.target.value)}
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <Table
                className="table datanew dataTable no-footer"
                columns={enhancedColumns}
                rowHoverable={false}
                dataSource={freshFiltered}
                rowKey={(record: any) => record.id ?? record.mobileNumber}
                pagination={{
                    locale: { items_per_page: "" },
                    nextIcon: <i className="ti ti-chevron-right" />,
                    prevIcon: <i className="ti ti-chevron-left" />,
                    current: freshPagination.current,
                    pageSize: freshPagination.pageSize,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "30"],
                    showTotal: (total: number, range: [number, number]) =>
                        `Showing ${range[0]} - ${range[1]} of ${total} entries`,
                    onChange: (page: number, pageSize: number) => {
                        setFreshPagination({ current: page, pageSize });
                    },
                }}
            />
        </>
    );
};


export default FreshCallTable;